import { IconAlertTriangleFill } from "@amzn/stencil-react-components/icons";
import React from "react";
import { StatusEnum } from "../../hoc/with-status";
import "./styles.scss";

interface StatusProps {
  status?: StatusEnum;
}
const classNames = {
  [StatusEnum.LOADING]: "loading",
  [StatusEnum.NOT_STARTED]: "not-started",
  [StatusEnum.IN_PROGRESS]: "in-progress",
  [StatusEnum.COMPLETED]: "completed",
  [StatusEnum.API_ERROR]: "na",
  [StatusEnum.ERROR]: "error",
  [StatusEnum.HIDDEN]: "hidden",
  [StatusEnum.PENDING_REVIEW]: "in-progress",
  [StatusEnum.ELIGIBLE]: "eligible",
  [StatusEnum.INELIGIBLE]: "ineligible",
};

export const Status = ({ status }: StatusProps) => {
  if (!status) {
    return null;
  }

  const className = `status ${classNames[status as StatusEnum]}`;
  if (status == StatusEnum.ERROR) {
    return (
      <span className={className}>
        <IconAlertTriangleFill color={"#cc7a00;"} />
      </span>
    );
  }

  return <span className={className}>{status}</span>;
};
